'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled from 'styled-components';

var SkillContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n"], ["\n    position: relative;\n"])));
var Button = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n"], ["\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n"])));
var templateObject_1, templateObject_2;

export { Button, SkillContainer };
//# sourceMappingURL=styles.js.map
